import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { numberTransition } from "../../helpers/numberTransition";

export const gsapAnimateOnScroll = (function ($) {

    gsap.registerPlugin(ScrollTrigger);

    let els = gsap.utils.toArray(".animate");
    let numbers = gsap.utils.toArray(".js-number-transition");

    // === INSTRUCTIONS === //
    // MANDATORY properties on DOM elements
    // - class="animate"
    // - data-animation="...": with the corresponding class with animation (see animations.scss)
    // OPTIONAL properties on DOM elements:
    // - data-animation-delay="animation-delay-xx" (optional): where xx is a number from 1 to 20 (see animations.scss)
    function animateOnScroll(el) {
        let animation = el.getAttribute('data-animation');
        let dataDelay = el.getAttribute('data-animation-delay');
        // add delay class only if set
        let delay = (dataDelay !== null) ? dataDelay : 'animation-delay-default';
        // Add the animation class
        el.classList.add(animation, delay);
    }

    function init() {

        if (els.length > 0) {
            els.forEach(function (el) {
                ScrollTrigger.create({
                    trigger: el,
                    onEnter: () => animateOnScroll(el)
                })
            });
        }

        if (numbers.length > 0) {
            numbers.forEach(function (number) {
                ScrollTrigger.create({
                    trigger: number,
                    onEnter: () => numberTransition.init(number, number.getAttribute("data-number"), 2000, 'swing')
                })
            });
        }
    }

    return {
        init: init
    }

})(jQuery);